import React from 'react';
import styled from 'styled-components';
import { Icon } from 'fpay-ui';

const IconFalabella = styled(Icon)`
  width: 81px;
  height: 24px;
`;

export default function () {
  return <IconFalabella icon={"ic-financial-product-gray"} width={81} height={24} />;
}
